import { render, staticRenderFns } from "./WhatsappDropdown.vue?vue&type=template&id=5cb1c764&scoped=true&"
import script from "./WhatsappDropdown.vue?vue&type=script&lang=js&"
export * from "./WhatsappDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb1c764",
  null
  
)

export default component.exports